import React, { useCallback } from "react";
import "./AddToHomeScreen.css";

function AddToHomeScreenModal({ isOpen = false, onClose }) {
  const handleOverlayClick = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);

  const stopPropagation = (e) => e.stopPropagation();

  const handleGotIt = () => {
    if (onClose) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="add-to-home-overlay cm_bg_blur">
      <div className="add-to-home-container" onClick={stopPropagation}>
        <div className="add-to-home-header">
          <div className="add-to-home-icon">
            <i className="fa-solid fa-mobile-screen-button"></i>
          </div>
          <h3 className="add-to-home-title">Add to Home Screen</h3>
          <button type="button" className="add-to-home-close" onClick={handleGotIt}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="add-to-home-content">
          <p className="add-to-home-description">
            Get instant notifications for new alerts by adding our web app to your home screen. Here's how to do it:
          </p>

          <div className="add-to-home-steps">
            <div className="add-to-home-step">
              <div className="add-to-home-step-number">1</div>
              <div className="add-to-home-step-content">
                <p>
                  Open your browser and tap the <strong>"Share"</strong> icon (it looks like a box with an arrow pointing up) next to the search bar.
                </p>
                <p className="add-to-home-step-note">
                  If you're on iPhone and have the latest iOS version, tap the three dots (<strong>…</strong>).
                </p>
              </div>
            </div>

            <div className="add-to-home-step">
              <div className="add-to-home-step-number">2</div>
              <div className="add-to-home-step-content">
                <p>
                  Select <strong>"Add to Home Screen"</strong>.
                </p>
                <p className="add-to-home-step-note">
                  If you're on the latest iOS version scroll down to see this.
                </p>
              </div>
            </div>

            <div className="add-to-home-step">
              <div className="add-to-home-step-number">3</div>
              <div className="add-to-home-step-content">
                <p>
                  Tap <strong>"Add"</strong> in the top right to finish.
                </p>
              </div>
            </div>
          </div>

          <button
            type="button"
            className="add-to-home-button mt-3"
            onClick={handleGotIt}
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddToHomeScreenModal;


